import styled from 'styled-components';

export const ChartSection = styled.section`
    padding:2rem 0rem;
`;

export const ChartContainer= styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    box-sizing:border-box;
    padding:1rem;
    @media(min-width:900px){
        width:75%;
        margin:auto;
    }
`;